export default {
  getCategories(state) {
    return state.categories;
  },
  getCategory(state) {
    return state.category;
  },
};
